/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Arch_BrowserInputs */

const en_fc_dl_arch_browser = /** @type {(inputs: Fc_Dl_Arch_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any modern browser`)
};

/**
* | output |
* | --- |
* | "Any modern browser" |
*
* @param {Fc_Dl_Arch_BrowserInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_arch_browser = /** @type {((inputs?: Fc_Dl_Arch_BrowserInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Arch_BrowserInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_arch_browser(inputs)
});
export { fc_dl_arch_browser as "fc.dl.arch.browser" }